import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink, UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import ArticleIcon from '../../../../../components/Blog/ArticleIcon';
import TagLinks from '../../../../../components/Blog/TagLinks';
import {
  formatDate,
  isPublishedNow,
  itemDate,
  itemTags,
  itemUrl,
} from '../../../../../components/Blog/utils';

const DefaultTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <UniversalLink href={href}>{linkTitle || href}</UniversalLink>;
  }

  return (
    <>
      <div className="items ehon-card-grid">
        {items.filter(isPublishedNow).map((item, index) => {
          const url = itemUrl(item);
          return (
            <article
              className={`listing-item ehon-card ${
                index === 0 ? 'ehon-card-featured' : ''
              }`}
              key={item['@id']}
            >
              {isEditMode ? (
                <div className="listing-body ehon-card-body">
                  <ArticleIcon item={item} />
                  <span className="ehon-card-date">
                    {formatDate(itemDate(item)) || '読書記録'}
                  </span>
                  <h3>
                    <span className="ehon-card-mark">›</span>{' '}
                    {item.title ? item.title : item.id}
                  </h3>
                  <TagLinks tags={itemTags(item)} compact />
                  {item.description && <p>{item.description}</p>}
                </div>
              ) : (
                <a href={url}>
                  <div className="listing-body ehon-card-body">
                    <ArticleIcon item={item} />
                    <span className="ehon-card-date">
                      {formatDate(itemDate(item)) || '読書記録'}
                    </span>
                    <h3>
                      <span className="ehon-card-mark">›</span>{' '}
                      {item.title ? item.title : item.id}
                    </h3>
                    <TagLinks tags={itemTags(item)} compact />
                    {item.description && <p>{item.description}</p>}
                  </div>
                </a>
              )}
            </article>
          );
        })}
      </div>

      {link && <div className="footer ehon-listing-footer">{link}</div>}
    </>
  );
};
DefaultTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};
export default DefaultTemplate;
